const binding = { modules: {}, dataActions: {} };

    (binding.modules['page-footer'] = {
        c: () => require('partner/modules/page-footer/page-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'page-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/page-footer'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|page-footer|page-footer'] = {
                c: () => require('partner/modules/page-footer/page-footer.view.tsx'),
                cn: '__local__-__local__-page-footer'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };